import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const AlertTriangle = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.7434 19.0839L13.0517 2.80624C12.4735 1.72112 11.5266 1.7364 10.9484 2.8215L2.25665 19.0766C1.67851 20.1617 2.11055 21 3.21685 21H20.7823C21.8894 21 22.3215 20.1672 21.7434 19.0839ZM13.4211 7.77173L12.9163 13.7015C12.9163 14.2075 12.5061 14.6177 12.0001 14.6177C11.4941 14.6177 11.0837 14.2075 11.0837 13.7015L10.5791 7.77173C10.5679 7.69913 10.5601 7.62513 10.5601 7.54893C10.5601 6.75373 11.2051 6.10913 12.0001 6.10913C12.7955 6.10913 13.4401 6.75373 13.4401 7.54893C13.4401 7.62513 13.4325 7.69913 13.4211 7.77173ZM12.0001 17.8905C11.2771 17.8905 10.6911 17.3045 10.6911 16.5815C10.6911 15.8585 11.2771 15.2725 12.0001 15.2725C12.7231 15.2725 13.3093 15.8585 13.3093 16.5815C13.3093 17.3045 12.7231 17.8905 12.0001 17.8905Z"
            fill={color}
        />
    </StarryUIIcon>
);
